import React, { useEffect } from "react";
import { Box, Button, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import { fetchListAbsensiBulanan } from "state/absensiActions";
import SortableHeader from "components/SortableHeader";
import { FilterList } from "@mui/icons-material";
import CustomFilterModal from "./CustomFilterModal";
moment.locale("id");

const RekapAbsensiBulanan = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { list_absensi_bulanan } = useSelector((state) => state.absensi);
  useEffect(() => {
    dispatch(fetchListAbsensiBulanan());
  }, []);

  const [filteredData, setFilteredData] = React.useState([]);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);

  const columnSort = [
    { value: "id_karyawan", label: "ID Karyawan" },
    { value: "nama_karyawan", label: "Nama Karyawan" },
    { value: "tanggal", label: "Tanggal" },
    { value: "telat_menit", label: "Telat Menit" },
  ];

  useEffect(() => {
    // Apply filters whenever data or filters change
    if (list_absensi_bulanan) {
      const filtered = applyCustomFilters(list_absensi_bulanan, appliedFilters);
      setFilteredData(filtered);
    }
  }, [list_absensi_bulanan, appliedFilters]);
  const handleApplyCustomFilter = (filters) => {
    setAppliedFilters(filters);
  };

  // Main filter logic
  const applyCustomFilters = (data, filterConfig) => {
    if (!filterConfig || Object.keys(filterConfig).length === 0) return data;

    let result = [...data];

    // Apply Category filters
    if (filterConfig.filter) {
      if (filterConfig.filter.cabang && filterConfig.filter.cabang.length > 0) {
        result = result.filter((row) => {
          return filterConfig.filter.cabang.includes(row.cabang);
        });
      }

      if (filterConfig.filter.bulan && filterConfig.filter.bulan.length > 0) {
        result = result.filter((row) => {
          return filterConfig.filter.bulan.includes(row.bulan);
        });
      }
    }

    return result;
  };

  const handleClearCustomFilter = () => {
    setAppliedFilters({});
    setFilteredData([]);
  };
  // Count active filters
  const getActiveFilterCount = () => {
    let count = 0;

    // ✅ Search
    if (appliedFilters.search && appliedFilters.search.trim() !== "") {
      count++;
    }

    // ✅ Date Range
    if (appliedFilters.dateRange) {
      if (
        appliedFilters.dateRange.tanggalAwal ||
        appliedFilters.dateRange.tanggalAkhir
      ) {
        count++;
      }
    }

    // ✅ Filter
    if (appliedFilters.filter) {
      if (appliedFilters.filter.cabang?.length > 0) count++;
      if (appliedFilters.filter.bulan?.length > 0) count++;
    }

    // ✅ Sort (multiple)
    if (
      Array.isArray(appliedFilters.sort) &&
      appliedFilters.sort.some(
        (item) => item.column && item.column.trim() !== "",
      )
    ) {
      count++;
    }

    return count;
  };

  const columnsAbsensi = [
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "cabang",
      label: "Nama Cabang",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },

    {
      name: "bulan",
      label: "Bulan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_hadir",
      label: "Jumlah Hadir",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_izin",
      label: "Jumlah Izin",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_tidak_hadir",
      label: "Jumlah Tidak Hadir",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "total_telat",
      label: "Total Telat (Menit)",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        // customBodyRender: (value) => `${Number(value).toFixed(0)}`,
        customBodyRender: (value) => {
          const isLate = value > 0;
          const style = isLate
            ? { color: "red", fontWeight: "bold" }
            : { color: "black" };
          return <span style={style}>{Number(value).toFixed(0)}</span>;
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    filter: false,
    fixedHeader: false,
    fixedSelectColumn: false,
    search: true,
    viewColumns: false,
    responsive: "standard",
    customToolbar: () => {
      const activeCount = getActiveFilterCount();
      return (
        <Button
          startIcon={<FilterList />}
          onClick={() => setOpenCustomFilter(true)}
          variant={activeCount > 0 ? "contained" : "outlined"}
          size="small"
          color={activeCount > 0 ? "primary" : "inherit"}
          sx={{
            mr: 1,
            ...(activeCount === 0 && {
              color: "text.secondary",
              borderColor: "text.secondary",
            }),
          }}
        >
          Filter {activeCount > 0 && `(${activeCount})`}
        </Button>
      );
    },
    rowsPerPageOptions: [
      30,
      60,
      filteredData.length > 0 || Object.keys(appliedFilters).length > 0
        ? filteredData.length
        : list_absensi_bulanan.length,
    ],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Rekap Absensi Bulanan"
        subtitle="Daftar absensi bulanan karyawan."
      />
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={
            filteredData.length > 0 || Object.keys(appliedFilters).length > 0
              ? filteredData
              : list_absensi_bulanan
          }
          columns={columnsAbsensi}
          options={options}
        />
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_absensi_bulanan}
          sortableColumns={columnSort}
        />
      </Box>
    </Box>
  );
};

export default RekapAbsensiBulanan;
